import React from "react";
import { useLanguage } from "../../context/LanguageContext";

const StatsSection = () => {
  const { t } = useLanguage();

  const statsData = [
    {
      value: "4%+",
      label: t("statsSection.gdpGrowth"),
      color: "info",
    },
    {
      value: "96M",
      label: t("statsSection.annualPassengers"),
      color: "warning",
    },
    {
      value: "75%",
      label: t("statsSection.nonOilGdp"),
      color: "info",
    },
    {
      value: "#1",
      label: t("statsSection.countryRanking"),
      color: "warning",
    },
  ];

  return (
    <div className="stats-section py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="d-flex flex-wrap justify-content-center gap-4">
              {statsData.map((stat, index) => (
                <div
                  key={index}
                  className="stats-card text-center p-4 shadow"
                  style={{
                    backgroundColor: "rgba(33, 37, 41, 0.4)",
                    borderRadius: "25px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    minWidth: "200px",
                    flex: "1",
                    maxWidth: "250px"
                  }}
                >
                                     <div className={`stats-value mb-2 text-${stat.color}`} style={{ 
                     fontSize: "1.5rem", 
                     fontWeight: "bold" 
                   }}>
                     {stat.value}
                   </div>
                  <div className="stats-label text-white" style={{ 
                    fontSize: "0.9rem",
                    lineHeight: "1.3"
                  }}>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
